module.exports = __webpack_public_path__ + "static/AffiliateWorldConference-574c14d1b944b734c4ae6ccc770e9b1f.jpg";